"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../../utils/system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /**
   * Move the icon to right placement.
   */
  end: _propTypes.bool
};
var defaultProps = {
  end: false
};
var ListItemIcon = (0, _system["default"])('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['end'].includes(prop);
  }
})({
  label: 'ListItemIcon'
}, (0, _css["default"])({
  alignItems: 'center',
  boxSizing: 'border-box',
  color: 'text',
  display: 'inline-flex',
  flexShrink: 0,
  minWidth: 12
}), function (_ref) {
  var end = _ref.end;
  return end && {
    justifyContent: 'flex-end'
  };
});
ListItemIcon.displayName = 'ListItemIcon';
ListItemIcon.propTypes = propTypes;
ListItemIcon.defaultProps = defaultProps;
var _default = ListItemIcon;
exports["default"] = _default;

//# sourceMappingURL=ListItemIcon.js.map